import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const RadioField = ({ label, value, onChange, disabled, required, options }) => {
  const radioOptions = options ? options.split(",") : [];
  
  return (
    <FormControl
      component="fieldset"
      margin="normal"
      required={required}
      disabled={disabled}
      sx={{
        width: "100%",

        "& .MuiFormLabel-root": {
          color: "#c1cddb",

          "&.Mui-focused": {
            color: "#c1cddb",
          },
        },

        ...(disabled && {
          "& .MuiFormLabel-root": {
            color: "#a7bbcf !important",
          },

          "& .MuiFormControlLabel-label": {
            color: "gray !important",
          }
        }),
      }}
    >
      <FormLabel component="legend">{label}</FormLabel>

      <RadioGroup
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {radioOptions.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={
              <Radio
                sx={{
                  color: "#c1cddb",

                  "&.Mui-checked": {
                    color: "white",
                  },

                  ...(disabled && {
                    color: "gray !important",
                  })
                }}
              />
            }
            label={option}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioField;